import { computed, type Ref } from 'vue';
import type { CompanyPayout, CompanyPayoutEntry, Payout } from '@/entities/Entities';

export interface AmountByType {
    chf: number;
    holiday: number;
    voucher: number;
}

export interface StatisticsItem {
  pending?: AmountByType;
  inPayment?: AmountByType;
  payed?: AmountByType;
  error?: AmountByType;

  total?: AmountByType;
}

export type PayoutStatus = keyof StatisticsItem;
export type PayoutType = keyof AmountByType;

export interface Statistics {
  filtered?: StatisticsItem;
  selected?: StatisticsItem;
  total: StatisticsItem;
}
// eslint-disable-next-line import/prefer-default-export
export function calculateSelectedCompanyPayoutStatistics(payouts: Ref<CompanyPayout[]>) {
  const selectedCompanyPayoutStatistics = computed<StatisticsItem>(() => {
    const total = {} as AmountByType;
    const out = {} as StatisticsItem;
    payouts.value.forEach((payout) => {
      if (!payout.status) return;
      const status = payout.status as PayoutStatus;
      if (!out[status]) {
        out[status] = {} as AmountByType;
      }

      payout.entries?.forEach((entry) => {
        const type = entry.type as PayoutType;
        if (out[status] && !out[status][type]) {
          out[status][type] = 0;
        }
        if (out[status]) out[status][type] += entry.amount ?? 0;

        if (!total[type]) {
          total[type] = 0;
        }
        total[type] += entry.amount ?? 0;
      });
    });
    out.total = total;
    return out;
  });

  return selectedCompanyPayoutStatistics;
}
